function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.VueMultiselect = e() : t.VueMultiselect = e();
}(this, function () {
  return function (t) {
    function e(i) {
      if (n[i]) return n[i].exports;
      var r = n[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.i = function (t) {
      return t;
    }, e.d = function (t, n, i) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: i
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "/", e(e.s = 60);
  }([function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (t, e, n) {
    var i = n(49)("wks"),
        r = n(30),
        o = n(0).Symbol,
        s = "function" == typeof o;
    (t.exports = function (t) {
      return i[t] || (i[t] = s && o[t] || (s ? o : r)("Symbol." + t));
    }).store = i;
  }, function (t, e, n) {
    var i = n(5);

    t.exports = function (t) {
      if (!i(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(10),
        o = n(8),
        s = n(6),
        u = n(11),
        a = function a(t, e, n) {
      var l,
          c,
          f,
          p,
          h = t & a.F,
          d = t & a.G,
          v = t & a.S,
          g = t & a.P,
          y = t & a.B,
          m = d ? i : v ? i[e] || (i[e] = {}) : (i[e] || {}).prototype,
          b = d ? r : r[e] || (r[e] = {}),
          _ = b.prototype || (b.prototype = {});

      d && (n = e);

      for (l in n) {
        c = !h && m && void 0 !== m[l], f = (c ? m : n)[l], p = y && c ? u(f, i) : g && "function" == typeof f ? u(Function.call, f) : f, m && s(m, l, f, t & a.U), b[l] != f && o(b, l, p), g && _[l] != f && (_[l] = f);
      }
    };

    i.core = r, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
  }, function (t, e, n) {
    t.exports = !n(7)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(8),
        o = n(12),
        s = n(30)("src"),
        u = Function.toString,
        a = ("" + u).split("toString");
    n(10).inspectSource = function (t) {
      return u.call(t);
    }, (t.exports = function (t, e, n, u) {
      var l = "function" == typeof n;
      l && (o(n, "name") || r(n, "name", e)), t[e] !== n && (l && (o(n, s) || r(n, s, t[e] ? "" + t[e] : a.join(String(e)))), t === i ? t[e] = n : u ? t[e] ? t[e] = n : r(t, e, n) : (delete t[e], r(t, e, n)));
    })(Function.prototype, "toString", function () {
      return "function" == typeof this && this[s] || u.call(this);
    });
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e, n) {
    var i = n(13),
        r = n(25);
    t.exports = n(4) ? function (t, e, n) {
      return i.f(t, e, r(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    var n = t.exports = {
      version: "2.5.7"
    };
    "number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var i = n(14);

    t.exports = function (t, e, n) {
      if (i(t), void 0 === e) return t;

      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, i) {
            return t.call(e, n, i);
          };

        case 3:
          return function (n, i, r) {
            return t.call(e, n, i, r);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e) {
    var n = {}.hasOwnProperty;

    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(41),
        o = n(29),
        s = Object.defineProperty;
    e.f = n(4) ? Object.defineProperty : function (t, e, n) {
      if (i(t), e = o(e, !0), i(n), r) try {
        return s(t, e, n);
      } catch (t) {}
      if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
      return "value" in n && (t[e] = n.value), t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e) {
    t.exports = {};
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(7);

    t.exports = function (t, e) {
      return !!t && i(function () {
        e ? t.call(null, function () {}, 1) : t.call(null);
      });
    };
  }, function (t, e, n) {
    var i = n(23),
        r = n(16);

    t.exports = function (t) {
      return i(r(t));
    };
  }, function (t, e, n) {
    var i = n(53),
        r = Math.min;

    t.exports = function (t) {
      return t > 0 ? r(i(t), 9007199254740991) : 0;
    };
  }, function (t, e, n) {
    var i = n(11),
        r = n(23),
        o = n(28),
        s = n(19),
        u = n(64);

    t.exports = function (t, e) {
      var n = 1 == t,
          a = 2 == t,
          l = 3 == t,
          c = 4 == t,
          f = 6 == t,
          p = 5 == t || f,
          h = e || u;
      return function (e, u, d) {
        for (var v, g, y = o(e), m = r(y), b = i(u, d, 3), _ = s(m.length), x = 0, w = n ? h(e, _) : a ? h(e, 0) : void 0; _ > x; x++) {
          if ((p || x in m) && (v = m[x], g = b(v, x, y), t)) if (n) w[x] = g;else if (g) switch (t) {
            case 3:
              return !0;

            case 5:
              return v;

            case 6:
              return x;

            case 2:
              w.push(v);
          } else if (c) return !1;
        }

        return f ? -1 : l || c ? c : w;
      };
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(0).document,
        o = i(r) && i(r.createElement);

    t.exports = function (t) {
      return o ? r.createElement(t) : {};
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e, n) {
    var i = n(9);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == i(t) ? t.split("") : Object(t);
    };
  }, function (t, e) {
    t.exports = !1;
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e, n) {
    var i = n(13).f,
        r = n(12),
        o = n(1)("toStringTag");

    t.exports = function (t, e, n) {
      t && !r(t = n ? t : t.prototype, o) && i(t, o, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e, n) {
    var i = n(49)("keys"),
        r = n(30);

    t.exports = function (t) {
      return i[t] || (i[t] = r(t));
    };
  }, function (t, e, n) {
    var i = n(16);

    t.exports = function (t) {
      return Object(i(t));
    };
  }, function (t, e, n) {
    var i = n(5);

    t.exports = function (t, e) {
      if (!i(t)) return t;
      var n, r;
      if (e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;
      if ("function" == typeof (n = t.valueOf) && !i(r = n.call(t))) return r;
      if (!e && "function" == typeof (n = t.toString) && !i(r = n.call(t))) return r;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e) {
    var n = 0,
        i = Math.random();

    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + i).toString(36));
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(0),
        r = n(12),
        o = n(9),
        s = n(67),
        u = n(29),
        a = n(7),
        l = n(77).f,
        c = n(45).f,
        f = n(13).f,
        p = n(51).trim,
        _h = i.Number,
        d = _h,
        v = _h.prototype,
        g = "Number" == o(n(44)(v)),
        y = ("trim" in String.prototype),
        m = function m(t) {
      var e = u(t, !1);

      if ("string" == typeof e && e.length > 2) {
        e = y ? e.trim() : p(e, 3);
        var n,
            i,
            r,
            o = e.charCodeAt(0);

        if (43 === o || 45 === o) {
          if (88 === (n = e.charCodeAt(2)) || 120 === n) return NaN;
        } else if (48 === o) {
          switch (e.charCodeAt(1)) {
            case 66:
            case 98:
              i = 2, r = 49;
              break;

            case 79:
            case 111:
              i = 8, r = 55;
              break;

            default:
              return +e;
          }

          for (var s, a = e.slice(2), l = 0, c = a.length; l < c; l++) {
            if ((s = a.charCodeAt(l)) < 48 || s > r) return NaN;
          }

          return parseInt(a, i);
        }
      }

      return +e;
    };

    if (!_h(" 0o1") || !_h("0b1") || _h("+0x1")) {
      _h = function h(t) {
        var e = arguments.length < 1 ? 0 : t,
            n = this;
        return n instanceof _h && (g ? a(function () {
          v.valueOf.call(n);
        }) : "Number" != o(n)) ? s(new d(m(e)), n, _h) : m(e);
      };

      for (var b, _ = n(4) ? l(d) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), x = 0; _.length > x; x++) {
        r(d, b = _[x]) && !r(_h, b) && f(_h, b, c(d, b));
      }

      _h.prototype = v, v.constructor = _h, n(6)(i, "Number", _h);
    }
  }, function (t, e, n) {
    "use strict";

    function i(t) {
      return 0 !== t && (!(!Array.isArray(t) || 0 !== t.length) || !t);
    }

    function r(t) {
      return function () {
        return !t.apply(void 0, arguments);
      };
    }

    function o(t, e) {
      return void 0 === t && (t = "undefined"), null === t && (t = "null"), !1 === t && (t = "false"), -1 !== t.toString().toLowerCase().indexOf(e.trim());
    }

    function s(t, e, n, i) {
      return t.filter(function (t) {
        return o(i(t, n), e);
      });
    }

    function u(t) {
      return t.filter(function (t) {
        return !t.$isLabel;
      });
    }

    function a(t, e) {
      return function (n) {
        return n.reduce(function (n, i) {
          return i[t] && i[t].length ? (n.push({
            $groupLabel: i[e],
            $isLabel: !0
          }), n.concat(i[t])) : n;
        }, []);
      };
    }

    function l(t, e, i, r, o) {
      return function (u) {
        return u.map(function (u) {
          var a;
          if (!u[i]) return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."), [];
          var l = s(u[i], t, e, o);
          return l.length ? (a = {}, n.i(d.a)(a, r, u[r]), n.i(d.a)(a, i, l), a) : [];
        });
      };
    }

    var c = n(59),
        f = n(54),
        p = (n.n(f), n(95)),
        h = (n.n(p), n(31)),
        d = (n.n(h), n(58)),
        v = n(91),
        g = (n.n(v), n(98)),
        y = (n.n(g), n(92)),
        m = (n.n(y), n(88)),
        b = (n.n(m), n(97)),
        _ = (n.n(b), n(89)),
        x = (n.n(_), n(96)),
        w = (n.n(x), n(93)),
        S = (n.n(w), n(90)),
        O = (n.n(S), function () {
      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
        e[n] = arguments[n];
      }

      return function (t) {
        return e.reduce(function (t, e) {
          return e(t);
        }, t);
      };
    });

    e.a = {
      data: function data() {
        return {
          search: "",
          isOpen: !1,
          preferredOpenDirection: "below",
          optimizedHeight: this.maxHeight
        };
      },
      props: {
        internalSearch: {
          type: Boolean,
          "default": !0
        },
        options: {
          type: Array,
          required: !0
        },
        multiple: {
          type: Boolean,
          "default": !1
        },
        value: {
          type: null,
          "default": function _default() {
            return [];
          }
        },
        trackBy: {
          type: String
        },
        label: {
          type: String
        },
        searchable: {
          type: Boolean,
          "default": !0
        },
        clearOnSelect: {
          type: Boolean,
          "default": !0
        },
        hideSelected: {
          type: Boolean,
          "default": !1
        },
        placeholder: {
          type: String,
          "default": "Select option"
        },
        allowEmpty: {
          type: Boolean,
          "default": !0
        },
        resetAfter: {
          type: Boolean,
          "default": !1
        },
        closeOnSelect: {
          type: Boolean,
          "default": !0
        },
        customLabel: {
          type: Function,
          "default": function _default(t, e) {
            return i(t) ? "" : e ? t[e] : t;
          }
        },
        taggable: {
          type: Boolean,
          "default": !1
        },
        tagPlaceholder: {
          type: String,
          "default": "Press enter to create a tag"
        },
        tagPosition: {
          type: String,
          "default": "top"
        },
        max: {
          type: [Number, Boolean],
          "default": !1
        },
        id: {
          "default": null
        },
        optionsLimit: {
          type: Number,
          "default": 1e3
        },
        groupValues: {
          type: String
        },
        groupLabel: {
          type: String
        },
        groupSelect: {
          type: Boolean,
          "default": !1
        },
        blockKeys: {
          type: Array,
          "default": function _default() {
            return [];
          }
        },
        preserveSearch: {
          type: Boolean,
          "default": !1
        },
        preselectFirst: {
          type: Boolean,
          "default": !1
        }
      },
      mounted: function mounted() {
        !this.multiple && this.max && console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."), this.preselectFirst && !this.internalValue.length && this.options.length && this.select(this.filteredOptions[0]);
      },
      computed: {
        internalValue: function internalValue() {
          return this.value || 0 === this.value ? Array.isArray(this.value) ? this.value : [this.value] : [];
        },
        filteredOptions: function filteredOptions() {
          var t = this.search || "",
              e = t.toLowerCase().trim(),
              n = this.options.concat();
          return n = this.internalSearch ? this.groupValues ? this.filterAndFlat(n, e, this.label) : s(n, e, this.label, this.customLabel) : this.groupValues ? a(this.groupValues, this.groupLabel)(n) : n, n = this.hideSelected ? n.filter(r(this.isSelected)) : n, this.taggable && e.length && !this.isExistingOption(e) && ("bottom" === this.tagPosition ? n.push({
            isTag: !0,
            label: t
          }) : n.unshift({
            isTag: !0,
            label: t
          })), n.slice(0, this.optionsLimit);
        },
        valueKeys: function valueKeys() {
          var t = this;
          return this.trackBy ? this.internalValue.map(function (e) {
            return e[t.trackBy];
          }) : this.internalValue;
        },
        optionKeys: function optionKeys() {
          var t = this;
          return (this.groupValues ? this.flatAndStrip(this.options) : this.options).map(function (e) {
            return t.customLabel(e, t.label).toString().toLowerCase();
          });
        },
        currentOptionLabel: function currentOptionLabel() {
          return this.multiple ? this.searchable ? "" : this.placeholder : this.internalValue.length ? this.getOptionLabel(this.internalValue[0]) : this.searchable ? "" : this.placeholder;
        }
      },
      watch: {
        internalValue: function internalValue() {
          this.resetAfter && this.internalValue.length && (this.search = "", this.$emit("input", this.multiple ? [] : null));
        },
        search: function search() {
          this.$emit("search-change", this.search, this.id);
        }
      },
      methods: {
        getValue: function getValue() {
          return this.multiple ? this.internalValue : 0 === this.internalValue.length ? null : this.internalValue[0];
        },
        filterAndFlat: function filterAndFlat(t, e, n) {
          return O(l(e, n, this.groupValues, this.groupLabel, this.customLabel), a(this.groupValues, this.groupLabel))(t);
        },
        flatAndStrip: function flatAndStrip(t) {
          return O(a(this.groupValues, this.groupLabel), u)(t);
        },
        updateSearch: function updateSearch(t) {
          this.search = t;
        },
        isExistingOption: function isExistingOption(t) {
          return !!this.options && this.optionKeys.indexOf(t) > -1;
        },
        isSelected: function isSelected(t) {
          var e = this.trackBy ? t[this.trackBy] : t;
          return this.valueKeys.indexOf(e) > -1;
        },
        isOptionDisabled: function isOptionDisabled(t) {
          return !!t.$isDisabled;
        },
        getOptionLabel: function getOptionLabel(t) {
          if (i(t)) return "";
          if (t.isTag) return t.label;
          if (t.$isLabel) return t.$groupLabel;
          var e = this.customLabel(t, this.label);
          return i(e) ? "" : e;
        },
        select: function select(t, e) {
          if (t.$isLabel && this.groupSelect) return void this.selectGroup(t);

          if (!(-1 !== this.blockKeys.indexOf(e) || this.disabled || t.$isDisabled || t.$isLabel) && (!this.max || !this.multiple || this.internalValue.length !== this.max) && ("Tab" !== e || this.pointerDirty)) {
            if (t.isTag) this.$emit("tag", t.label, this.id), this.search = "", this.closeOnSelect && !this.multiple && this.deactivate();else {
              if (this.isSelected(t)) return void ("Tab" !== e && this.removeElement(t));
              this.$emit("select", t, this.id), this.multiple ? this.$emit("input", this.internalValue.concat([t]), this.id) : this.$emit("input", t, this.id), this.clearOnSelect && (this.search = "");
            }
            this.closeOnSelect && this.deactivate();
          }
        },
        selectGroup: function selectGroup(t) {
          var e = this,
              n = this.options.find(function (n) {
            return n[e.groupLabel] === t.$groupLabel;
          });
          if (n) if (this.wholeGroupSelected(n)) {
            this.$emit("remove", n[this.groupValues], this.id);
            var i = this.internalValue.filter(function (t) {
              return -1 === n[e.groupValues].indexOf(t);
            });
            this.$emit("input", i, this.id);
          } else {
            var r = n[this.groupValues].filter(function (t) {
              return !(e.isOptionDisabled(t) || e.isSelected(t));
            });
            this.$emit("select", r, this.id), this.$emit("input", this.internalValue.concat(r), this.id);
          }
        },
        wholeGroupSelected: function wholeGroupSelected(t) {
          var e = this;
          return t[this.groupValues].every(function (t) {
            return e.isSelected(t) || e.isOptionDisabled(t);
          });
        },
        wholeGroupDisabled: function wholeGroupDisabled(t) {
          return t[this.groupValues].every(this.isOptionDisabled);
        },
        removeElement: function removeElement(t) {
          var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

          if (!this.disabled && !t.$isDisabled) {
            if (!this.allowEmpty && this.internalValue.length <= 1) return void this.deactivate();
            var i = "object" === n.i(c.a)(t) ? this.valueKeys.indexOf(t[this.trackBy]) : this.valueKeys.indexOf(t);

            if (this.$emit("remove", t, this.id), this.multiple) {
              var r = this.internalValue.slice(0, i).concat(this.internalValue.slice(i + 1));
              this.$emit("input", r, this.id);
            } else this.$emit("input", null, this.id);

            this.closeOnSelect && e && this.deactivate();
          }
        },
        removeLastElement: function removeLastElement() {
          -1 === this.blockKeys.indexOf("Delete") && 0 === this.search.length && Array.isArray(this.internalValue) && this.internalValue.length && this.removeElement(this.internalValue[this.internalValue.length - 1], !1);
        },
        activate: function activate() {
          var t = this;
          this.isOpen || this.disabled || (this.adjustPosition(), this.groupValues && 0 === this.pointer && this.filteredOptions.length && (this.pointer = 1), this.isOpen = !0, this.searchable ? (this.preserveSearch || (this.search = ""), this.$nextTick(function () {
            return t.$refs.search.focus();
          })) : this.$el.focus(), this.$emit("open", this.id));
        },
        deactivate: function deactivate() {
          this.isOpen && (this.isOpen = !1, this.searchable ? this.$refs.search.blur() : this.$el.blur(), this.preserveSearch || (this.search = ""), this.$emit("close", this.getValue(), this.id));
        },
        toggle: function toggle() {
          this.isOpen ? this.deactivate() : this.activate();
        },
        adjustPosition: function adjustPosition() {
          if ("undefined" != typeof window) {
            var t = this.$el.getBoundingClientRect().top,
                e = window.innerHeight - this.$el.getBoundingClientRect().bottom;
            e > this.maxHeight || e > t || "below" === this.openDirection || "bottom" === this.openDirection ? (this.preferredOpenDirection = "below", this.optimizedHeight = Math.min(e - 40, this.maxHeight)) : (this.preferredOpenDirection = "above", this.optimizedHeight = Math.min(t - 40, this.maxHeight));
          }
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(54),
        r = (n.n(i), n(31));
    n.n(r);
    e.a = {
      data: function data() {
        return {
          pointer: 0,
          pointerDirty: !1
        };
      },
      props: {
        showPointer: {
          type: Boolean,
          "default": !0
        },
        optionHeight: {
          type: Number,
          "default": 40
        }
      },
      computed: {
        pointerPosition: function pointerPosition() {
          return this.pointer * this.optionHeight;
        },
        visibleElements: function visibleElements() {
          return this.optimizedHeight / this.optionHeight;
        }
      },
      watch: {
        filteredOptions: function filteredOptions() {
          this.pointerAdjust();
        },
        isOpen: function isOpen() {
          this.pointerDirty = !1;
        }
      },
      methods: {
        optionHighlight: function optionHighlight(t, e) {
          return {
            "multiselect__option--highlight": t === this.pointer && this.showPointer,
            "multiselect__option--selected": this.isSelected(e)
          };
        },
        groupHighlight: function groupHighlight(t, e) {
          var n = this;
          if (!this.groupSelect) return ["multiselect__option--group", "multiselect__option--disabled"];
          var i = this.options.find(function (t) {
            return t[n.groupLabel] === e.$groupLabel;
          });
          return i && !this.wholeGroupDisabled(i) ? ["multiselect__option--group", {
            "multiselect__option--highlight": t === this.pointer && this.showPointer
          }, {
            "multiselect__option--group-selected": this.wholeGroupSelected(i)
          }] : "multiselect__option--disabled";
        },
        addPointerElement: function addPointerElement() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Enter",
              e = t.key;
          this.filteredOptions.length > 0 && this.select(this.filteredOptions[this.pointer], e), this.pointerReset();
        },
        pointerForward: function pointerForward() {
          this.pointer < this.filteredOptions.length - 1 && (this.pointer++, this.$refs.list.scrollTop <= this.pointerPosition - (this.visibleElements - 1) * this.optionHeight && (this.$refs.list.scrollTop = this.pointerPosition - (this.visibleElements - 1) * this.optionHeight), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward()), this.pointerDirty = !0;
        },
        pointerBackward: function pointerBackward() {
          this.pointer > 0 ? (this.pointer--, this.$refs.list.scrollTop >= this.pointerPosition && (this.$refs.list.scrollTop = this.pointerPosition), this.filteredOptions[this.pointer] && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerBackward()) : this.filteredOptions[this.pointer] && this.filteredOptions[0].$isLabel && !this.groupSelect && this.pointerForward(), this.pointerDirty = !0;
        },
        pointerReset: function pointerReset() {
          this.closeOnSelect && (this.pointer = 0, this.$refs.list && (this.$refs.list.scrollTop = 0));
        },
        pointerAdjust: function pointerAdjust() {
          this.pointer >= this.filteredOptions.length - 1 && (this.pointer = this.filteredOptions.length ? this.filteredOptions.length - 1 : 0), this.filteredOptions.length > 0 && this.filteredOptions[this.pointer].$isLabel && !this.groupSelect && this.pointerForward();
        },
        pointerSet: function pointerSet(t) {
          this.pointer = t, this.pointerDirty = !0;
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(36),
        r = n(74),
        o = n(15),
        s = n(18);
    t.exports = n(72)(Array, "Array", function (t, e) {
      this._t = s(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
          e = this._k,
          n = this._i++;
      return !t || n >= t.length ? (this._t = void 0, r(1)) : "keys" == e ? r(0, n) : "values" == e ? r(0, t[n]) : r(0, [n, t[n]]);
    }, "values"), o.Arguments = o.Array, i("keys"), i("values"), i("entries");
  }, function (t, e, n) {
    "use strict";

    var i = n(31),
        r = (n.n(i), n(32)),
        o = n(33);
    e.a = {
      name: "vue-multiselect",
      mixins: [r.a, o.a],
      props: {
        name: {
          type: String,
          "default": ""
        },
        selectLabel: {
          type: String,
          "default": "Press enter to select"
        },
        selectGroupLabel: {
          type: String,
          "default": "Press enter to select group"
        },
        selectedLabel: {
          type: String,
          "default": "Selected"
        },
        deselectLabel: {
          type: String,
          "default": "Press enter to remove"
        },
        deselectGroupLabel: {
          type: String,
          "default": "Press enter to deselect group"
        },
        showLabels: {
          type: Boolean,
          "default": !0
        },
        limit: {
          type: Number,
          "default": 99999
        },
        maxHeight: {
          type: Number,
          "default": 300
        },
        limitText: {
          type: Function,
          "default": function _default(t) {
            return "and ".concat(t, " more");
          }
        },
        loading: {
          type: Boolean,
          "default": !1
        },
        disabled: {
          type: Boolean,
          "default": !1
        },
        openDirection: {
          type: String,
          "default": ""
        },
        showNoOptions: {
          type: Boolean,
          "default": !0
        },
        showNoResults: {
          type: Boolean,
          "default": !0
        },
        tabindex: {
          type: Number,
          "default": 0
        }
      },
      computed: {
        isSingleLabelVisible: function isSingleLabelVisible() {
          return (this.singleValue || 0 === this.singleValue) && (!this.isOpen || !this.searchable) && !this.visibleValues.length;
        },
        isPlaceholderVisible: function isPlaceholderVisible() {
          return !(this.internalValue.length || this.searchable && this.isOpen);
        },
        visibleValues: function visibleValues() {
          return this.multiple ? this.internalValue.slice(0, this.limit) : [];
        },
        singleValue: function singleValue() {
          return this.internalValue[0];
        },
        deselectLabelText: function deselectLabelText() {
          return this.showLabels ? this.deselectLabel : "";
        },
        deselectGroupLabelText: function deselectGroupLabelText() {
          return this.showLabels ? this.deselectGroupLabel : "";
        },
        selectLabelText: function selectLabelText() {
          return this.showLabels ? this.selectLabel : "";
        },
        selectGroupLabelText: function selectGroupLabelText() {
          return this.showLabels ? this.selectGroupLabel : "";
        },
        selectedLabelText: function selectedLabelText() {
          return this.showLabels ? this.selectedLabel : "";
        },
        inputStyle: function inputStyle() {
          if (this.searchable || this.multiple && this.value && this.value.length) return this.isOpen ? {
            width: "100%"
          } : {
            width: "0",
            position: "absolute",
            padding: "0"
          };
        },
        contentStyle: function contentStyle() {
          return this.options.length ? {
            display: "inline-block"
          } : {
            display: "block"
          };
        },
        isAbove: function isAbove() {
          return "above" === this.openDirection || "top" === this.openDirection || "below" !== this.openDirection && "bottom" !== this.openDirection && "above" === this.preferredOpenDirection;
        },
        showSearchInput: function showSearchInput() {
          return this.searchable && (!this.hasSingleSelectedSlot || !this.visibleSingleValue && 0 !== this.visibleSingleValue || this.isOpen);
        }
      }
    };
  }, function (t, e, n) {
    var i = n(1)("unscopables"),
        r = Array.prototype;
    void 0 == r[i] && n(8)(r, i, {}), t.exports = function (t) {
      r[i][t] = !0;
    };
  }, function (t, e, n) {
    var i = n(18),
        r = n(19),
        o = n(85);

    t.exports = function (t) {
      return function (e, n, s) {
        var u,
            a = i(e),
            l = r(a.length),
            c = o(s, l);

        if (t && n != n) {
          for (; l > c;) {
            if ((u = a[c++]) != u) return !0;
          }
        } else for (; l > c; c++) {
          if ((t || c in a) && a[c] === n) return t || c || 0;
        }

        return !t && -1;
      };
    };
  }, function (t, e, n) {
    var i = n(9),
        r = n(1)("toStringTag"),
        o = "Arguments" == i(function () {
      return arguments;
    }()),
        s = function s(t, e) {
      try {
        return t[e];
      } catch (t) {}
    };

    t.exports = function (t) {
      var e, n, u;
      return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = s(e = Object(t), r)) ? n : o ? i(e) : "Object" == (u = i(e)) && "function" == typeof e.callee ? "Arguments" : u;
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(2);

    t.exports = function () {
      var t = i(this),
          e = "";
      return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
    };
  }, function (t, e, n) {
    var i = n(0).document;
    t.exports = i && i.documentElement;
  }, function (t, e, n) {
    t.exports = !n(4) && !n(7)(function () {
      return 7 != Object.defineProperty(n(21)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    var i = n(9);

    t.exports = Array.isArray || function (t) {
      return "Array" == i(t);
    };
  }, function (t, e, n) {
    "use strict";

    function i(t) {
      var e, n;
      this.promise = new t(function (t, i) {
        if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
        e = t, n = i;
      }), this.resolve = r(e), this.reject = r(n);
    }

    var r = n(14);

    t.exports.f = function (t) {
      return new i(t);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(76),
        o = n(22),
        s = n(27)("IE_PROTO"),
        u = function u() {},
        _a = function a() {
      var t,
          e = n(21)("iframe"),
          i = o.length;

      for (e.style.display = "none", n(40).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), _a = t.F; i--;) {
        delete _a.prototype[o[i]];
      }

      return _a();
    };

    t.exports = Object.create || function (t, e) {
      var n;
      return null !== t ? (u.prototype = i(t), n = new u(), u.prototype = null, n[s] = t) : n = _a(), void 0 === e ? n : r(n, e);
    };
  }, function (t, e, n) {
    var i = n(79),
        r = n(25),
        o = n(18),
        s = n(29),
        u = n(12),
        a = n(41),
        l = Object.getOwnPropertyDescriptor;
    e.f = n(4) ? l : function (t, e) {
      if (t = o(t), e = s(e, !0), a) try {
        return l(t, e);
      } catch (t) {}
      if (u(t, e)) return r(!i.f.call(t, e), t[e]);
    };
  }, function (t, e, n) {
    var i = n(12),
        r = n(18),
        o = n(37)(!1),
        s = n(27)("IE_PROTO");

    t.exports = function (t, e) {
      var n,
          u = r(t),
          a = 0,
          l = [];

      for (n in u) {
        n != s && i(u, n) && l.push(n);
      }

      for (; e.length > a;) {
        i(u, n = e[a++]) && (~o(l, n) || l.push(n));
      }

      return l;
    };
  }, function (t, e, n) {
    var i = n(46),
        r = n(22);

    t.exports = Object.keys || function (t) {
      return i(t, r);
    };
  }, function (t, e, n) {
    var i = n(2),
        r = n(5),
        o = n(43);

    t.exports = function (t, e) {
      if (i(t), r(e) && e.constructor === t) return e;
      var n = o.f(t);
      return (0, n.resolve)(e), n.promise;
    };
  }, function (t, e, n) {
    var i = n(10),
        r = n(0),
        o = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});
    (t.exports = function (t, e) {
      return o[t] || (o[t] = void 0 !== e ? e : {});
    })("versions", []).push({
      version: i.version,
      mode: n(24) ? "pure" : "global",
      copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
    });
  }, function (t, e, n) {
    var i = n(2),
        r = n(14),
        o = n(1)("species");

    t.exports = function (t, e) {
      var n,
          s = i(t).constructor;
      return void 0 === s || void 0 == (n = i(s)[o]) ? e : r(n);
    };
  }, function (t, e, n) {
    var i = n(3),
        r = n(16),
        o = n(7),
        s = n(84),
        u = "[" + s + "]",
        a = "​",
        l = RegExp("^" + u + u + "*"),
        c = RegExp(u + u + "*$"),
        f = function f(t, e, n) {
      var r = {},
          u = o(function () {
        return !!s[t]() || a[t]() != a;
      }),
          l = r[t] = u ? e(p) : s[t];
      n && (r[n] = l), i(i.P + i.F * u, "String", r);
    },
        p = f.trim = function (t, e) {
      return t = String(r(t)), 1 & e && (t = t.replace(l, "")), 2 & e && (t = t.replace(c, "")), t;
    };

    t.exports = f;
  }, function (t, e, n) {
    var i,
        r,
        o,
        s = n(11),
        u = n(68),
        a = n(40),
        l = n(21),
        c = n(0),
        f = c.process,
        p = c.setImmediate,
        h = c.clearImmediate,
        d = c.MessageChannel,
        v = c.Dispatch,
        g = 0,
        y = {},
        m = function m() {
      var t = +this;

      if (y.hasOwnProperty(t)) {
        var e = y[t];
        delete y[t], e();
      }
    },
        b = function b(t) {
      m.call(t.data);
    };

    p && h || (p = function p(t) {
      for (var e = [], n = 1; arguments.length > n;) {
        e.push(arguments[n++]);
      }

      return y[++g] = function () {
        u("function" == typeof t ? t : Function(t), e);
      }, i(g), g;
    }, h = function h(t) {
      delete y[t];
    }, "process" == n(9)(f) ? i = function i(t) {
      f.nextTick(s(m, t, 1));
    } : v && v.now ? i = function i(t) {
      v.now(s(m, t, 1));
    } : d ? (r = new d(), o = r.port2, r.port1.onmessage = b, i = s(o.postMessage, o, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (i = function i(t) {
      c.postMessage(t + "", "*");
    }, c.addEventListener("message", b, !1)) : i = "onreadystatechange" in l("script") ? function (t) {
      a.appendChild(l("script")).onreadystatechange = function () {
        a.removeChild(this), m.call(t);
      };
    } : function (t) {
      setTimeout(s(m, t, 1), 0);
    }), t.exports = {
      set: p,
      clear: h
    };
  }, function (t, e) {
    var n = Math.ceil,
        i = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? i : n)(t);
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(3),
        r = n(20)(5),
        o = !0;
    "find" in [] && Array(1).find(function () {
      o = !1;
    }), i(i.P + i.F * o, "Array", {
      find: function find(t) {
        return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
      }
    }), n(36)("find");
  }, function (t, e, n) {
    "use strict";

    var i,
        r,
        o,
        s,
        u = n(24),
        a = n(0),
        l = n(11),
        c = n(38),
        f = n(3),
        p = n(5),
        h = n(14),
        d = n(61),
        v = n(66),
        g = n(50),
        y = n(52).set,
        m = n(75)(),
        b = n(43),
        _ = n(80),
        x = n(86),
        w = n(48),
        S = a.TypeError,
        O = a.process,
        L = O && O.versions,
        k = L && L.v8 || "",
        _P = a.Promise,
        T = "process" == c(O),
        V = function V() {},
        E = r = b.f,
        A = !!function () {
      try {
        var t = _P.resolve(1),
            e = (t.constructor = {})[n(1)("species")] = function (t) {
          t(V, V);
        };

        return (T || "function" == typeof PromiseRejectionEvent) && t.then(V) instanceof e && 0 !== k.indexOf("6.6") && -1 === x.indexOf("Chrome/66");
      } catch (t) {}
    }(),
        C = function C(t) {
      var e;
      return !(!p(t) || "function" != typeof (e = t.then)) && e;
    },
        D = function D(t, e) {
      if (!t._n) {
        t._n = !0;
        var n = t._c;
        m(function () {
          for (var i = t._v, r = 1 == t._s, o = 0; n.length > o;) {
            !function (e) {
              var n,
                  o,
                  s,
                  u = r ? e.ok : e.fail,
                  a = e.resolve,
                  l = e.reject,
                  c = e.domain;

              try {
                u ? (r || (2 == t._h && $(t), t._h = 1), !0 === u ? n = i : (c && c.enter(), n = u(i), c && (c.exit(), s = !0)), n === e.promise ? l(S("Promise-chain cycle")) : (o = C(n)) ? o.call(n, a, l) : a(n)) : l(i);
              } catch (t) {
                c && !s && c.exit(), l(t);
              }
            }(n[o++]);
          }

          t._c = [], t._n = !1, e && !t._h && j(t);
        });
      }
    },
        j = function j(t) {
      y.call(a, function () {
        var e,
            n,
            i,
            r = t._v,
            o = N(t);
        if (o && (e = _(function () {
          T ? O.emit("unhandledRejection", r, t) : (n = a.onunhandledrejection) ? n({
            promise: t,
            reason: r
          }) : (i = a.console) && i.error && i.error("Unhandled promise rejection", r);
        }), t._h = T || N(t) ? 2 : 1), t._a = void 0, o && e.e) throw e.v;
      });
    },
        N = function N(t) {
      return 1 !== t._h && 0 === (t._a || t._c).length;
    },
        $ = function $(t) {
      y.call(a, function () {
        var e;
        T ? O.emit("rejectionHandled", t) : (e = a.onrejectionhandled) && e({
          promise: t,
          reason: t._v
        });
      });
    },
        F = function F(t) {
      var e = this;
      e._d || (e._d = !0, e = e._w || e, e._v = t, e._s = 2, e._a || (e._a = e._c.slice()), D(e, !0));
    },
        M = function M(t) {
      var e,
          n = this;

      if (!n._d) {
        n._d = !0, n = n._w || n;

        try {
          if (n === t) throw S("Promise can't be resolved itself");
          (e = C(t)) ? m(function () {
            var i = {
              _w: n,
              _d: !1
            };

            try {
              e.call(t, l(M, i, 1), l(F, i, 1));
            } catch (t) {
              F.call(i, t);
            }
          }) : (n._v = t, n._s = 1, D(n, !1));
        } catch (t) {
          F.call({
            _w: n,
            _d: !1
          }, t);
        }
      }
    };

    A || (_P = function P(t) {
      d(this, _P, "Promise", "_h"), h(t), i.call(this);

      try {
        t(l(M, this, 1), l(F, this, 1));
      } catch (t) {
        F.call(this, t);
      }
    }, i = function i(t) {
      this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
    }, i.prototype = n(81)(_P.prototype, {
      then: function then(t, e) {
        var n = E(g(this, _P));
        return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = T ? O.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && D(this, !1), n.promise;
      },
      "catch": function _catch(t) {
        return this.then(void 0, t);
      }
    }), o = function o() {
      var t = new i();
      this.promise = t, this.resolve = l(M, t, 1), this.reject = l(F, t, 1);
    }, b.f = E = function E(t) {
      return t === _P || t === s ? new o(t) : r(t);
    }), f(f.G + f.W + f.F * !A, {
      Promise: _P
    }), n(26)(_P, "Promise"), n(83)("Promise"), s = n(10).Promise, f(f.S + f.F * !A, "Promise", {
      reject: function reject(t) {
        var e = E(this);
        return (0, e.reject)(t), e.promise;
      }
    }), f(f.S + f.F * (u || !A), "Promise", {
      resolve: function resolve(t) {
        return w(u && this === s ? _P : this, t);
      }
    }), f(f.S + f.F * !(A && n(73)(function (t) {
      _P.all(t)["catch"](V);
    })), "Promise", {
      all: function all(t) {
        var e = this,
            n = E(e),
            i = n.resolve,
            r = n.reject,
            o = _(function () {
          var n = [],
              o = 0,
              s = 1;
          v(t, !1, function (t) {
            var u = o++,
                a = !1;
            n.push(void 0), s++, e.resolve(t).then(function (t) {
              a || (a = !0, n[u] = t, --s || i(n));
            }, r);
          }), --s || i(n);
        });

        return o.e && r(o.v), n.promise;
      },
      race: function race(t) {
        var e = this,
            n = E(e),
            i = n.reject,
            r = _(function () {
          v(t, !1, function (t) {
            e.resolve(t).then(n.resolve, i);
          });
        });

        return r.e && i(r.v), n.promise;
      }
    });
  }, function (t, e, n) {
    "use strict";

    var i = n(3),
        r = n(10),
        o = n(0),
        s = n(50),
        u = n(48);
    i(i.P + i.R, "Promise", {
      "finally": function _finally(t) {
        var e = s(this, r.Promise || o.Promise),
            n = "function" == typeof t;
        return this.then(n ? function (n) {
          return u(e, t()).then(function () {
            return n;
          });
        } : t, n ? function (n) {
          return u(e, t()).then(function () {
            throw n;
          });
        } : t);
      }
    });
  }, function (t, e, n) {
    "use strict";

    function i(t) {
      n(99);
    }

    var r = n(35),
        o = n(101),
        s = n(100),
        u = i,
        a = s(r.a, o.a, !1, u, null, null);
    e.a = a.exports;
  }, function (t, e, n) {
    "use strict";

    function i(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    e.a = i;
  }, function (t, e, n) {
    "use strict";

    function i(t) {
      return (i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
        return _typeof(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
      })(t);
    }

    function r(t) {
      return (r = "function" == typeof Symbol && "symbol" === i(Symbol.iterator) ? function (t) {
        return i(t);
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : i(t);
      })(t);
    }

    e.a = r;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var i = n(34),
        r = (n.n(i), n(55)),
        o = (n.n(r), n(56)),
        s = (n.n(o), n(57)),
        u = n(32),
        a = n(33);
    n.d(e, "Multiselect", function () {
      return s.a;
    }), n.d(e, "multiselectMixin", function () {
      return u.a;
    }), n.d(e, "pointerMixin", function () {
      return a.a;
    }), e["default"] = s.a;
  }, function (t, e) {
    t.exports = function (t, e, n, i) {
      if (!(t instanceof e) || void 0 !== i && i in t) throw TypeError(n + ": incorrect invocation!");
      return t;
    };
  }, function (t, e, n) {
    var i = n(14),
        r = n(28),
        o = n(23),
        s = n(19);

    t.exports = function (t, e, n, u, a) {
      i(e);
      var l = r(t),
          c = o(l),
          f = s(l.length),
          p = a ? f - 1 : 0,
          h = a ? -1 : 1;
      if (n < 2) for (;;) {
        if (p in c) {
          u = c[p], p += h;
          break;
        }

        if (p += h, a ? p < 0 : f <= p) throw TypeError("Reduce of empty array with no initial value");
      }

      for (; a ? p >= 0 : f > p; p += h) {
        p in c && (u = e(u, c[p], p, l));
      }

      return u;
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(42),
        o = n(1)("species");

    t.exports = function (t) {
      var e;
      return r(t) && (e = t.constructor, "function" != typeof e || e !== Array && !r(e.prototype) || (e = void 0), i(e) && null === (e = e[o]) && (e = void 0)), void 0 === e ? Array : e;
    };
  }, function (t, e, n) {
    var i = n(63);

    t.exports = function (t, e) {
      return new (i(t))(e);
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(8),
        r = n(6),
        o = n(7),
        s = n(16),
        u = n(1);

    t.exports = function (t, e, n) {
      var a = u(t),
          l = n(s, a, ""[t]),
          c = l[0],
          f = l[1];
      o(function () {
        var e = {};
        return e[a] = function () {
          return 7;
        }, 7 != ""[t](e);
      }) && (r(String.prototype, t, c), i(RegExp.prototype, a, 2 == e ? function (t, e) {
        return f.call(t, this, e);
      } : function (t) {
        return f.call(t, this);
      }));
    };
  }, function (t, e, n) {
    var i = n(11),
        r = n(70),
        o = n(69),
        s = n(2),
        u = n(19),
        a = n(87),
        l = {},
        c = {},
        e = t.exports = function (t, e, n, f, p) {
      var h,
          d,
          v,
          g,
          y = p ? function () {
        return t;
      } : a(t),
          m = i(n, f, e ? 2 : 1),
          b = 0;
      if ("function" != typeof y) throw TypeError(t + " is not iterable!");

      if (o(y)) {
        for (h = u(t.length); h > b; b++) {
          if ((g = e ? m(s(d = t[b])[0], d[1]) : m(t[b])) === l || g === c) return g;
        }
      } else for (v = y.call(t); !(d = v.next()).done;) {
        if ((g = r(v, m, d.value, e)) === l || g === c) return g;
      }
    };

    e.BREAK = l, e.RETURN = c;
  }, function (t, e, n) {
    var i = n(5),
        r = n(82).set;

    t.exports = function (t, e, n) {
      var o,
          s = e.constructor;
      return s !== n && "function" == typeof s && (o = s.prototype) !== n.prototype && i(o) && r && r(t, o), t;
    };
  }, function (t, e) {
    t.exports = function (t, e, n) {
      var i = void 0 === n;

      switch (e.length) {
        case 0:
          return i ? t() : t.call(n);

        case 1:
          return i ? t(e[0]) : t.call(n, e[0]);

        case 2:
          return i ? t(e[0], e[1]) : t.call(n, e[0], e[1]);

        case 3:
          return i ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);

        case 4:
          return i ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);
      }

      return t.apply(n, e);
    };
  }, function (t, e, n) {
    var i = n(15),
        r = n(1)("iterator"),
        o = Array.prototype;

    t.exports = function (t) {
      return void 0 !== t && (i.Array === t || o[r] === t);
    };
  }, function (t, e, n) {
    var i = n(2);

    t.exports = function (t, e, n, r) {
      try {
        return r ? e(i(n)[0], n[1]) : e(n);
      } catch (e) {
        var o = t["return"];
        throw void 0 !== o && i(o.call(t)), e;
      }
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(44),
        r = n(25),
        o = n(26),
        s = {};
    n(8)(s, n(1)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = i(s, {
        next: r(1, n)
      }), o(t, e + " Iterator");
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(24),
        r = n(3),
        o = n(6),
        s = n(8),
        u = n(15),
        a = n(71),
        l = n(26),
        c = n(78),
        f = n(1)("iterator"),
        p = !([].keys && "next" in [].keys()),
        h = function h() {
      return this;
    };

    t.exports = function (t, e, n, d, v, g, y) {
      a(n, e, d);

      var m,
          b,
          _,
          x = function x(t) {
        if (!p && t in L) return L[t];

        switch (t) {
          case "keys":
          case "values":
            return function () {
              return new n(this, t);
            };
        }

        return function () {
          return new n(this, t);
        };
      },
          w = e + " Iterator",
          S = "values" == v,
          O = !1,
          L = t.prototype,
          k = L[f] || L["@@iterator"] || v && L[v],
          P = k || x(v),
          T = v ? S ? x("entries") : P : void 0,
          V = "Array" == e ? L.entries || k : k;

      if (V && (_ = c(V.call(new t()))) !== Object.prototype && _.next && (l(_, w, !0), i || "function" == typeof _[f] || s(_, f, h)), S && k && "values" !== k.name && (O = !0, P = function P() {
        return k.call(this);
      }), i && !y || !p && !O && L[f] || s(L, f, P), u[e] = P, u[w] = h, v) if (m = {
        values: S ? P : x("values"),
        keys: g ? P : x("keys"),
        entries: T
      }, y) for (b in m) {
        b in L || o(L, b, m[b]);
      } else r(r.P + r.F * (p || O), e, m);
      return m;
    };
  }, function (t, e, n) {
    var i = n(1)("iterator"),
        r = !1;

    try {
      var o = [7][i]();
      o["return"] = function () {
        r = !0;
      }, Array.from(o, function () {
        throw 2;
      });
    } catch (t) {}

    t.exports = function (t, e) {
      if (!e && !r) return !1;
      var n = !1;

      try {
        var o = [7],
            s = o[i]();
        s.next = function () {
          return {
            done: n = !0
          };
        }, o[i] = function () {
          return s;
        }, t(o);
      } catch (t) {}

      return n;
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        value: e,
        done: !!t
      };
    };
  }, function (t, e, n) {
    var i = n(0),
        r = n(52).set,
        o = i.MutationObserver || i.WebKitMutationObserver,
        s = i.process,
        u = i.Promise,
        a = "process" == n(9)(s);

    t.exports = function () {
      var t,
          e,
          n,
          l = function l() {
        var i, r;

        for (a && (i = s.domain) && i.exit(); t;) {
          r = t.fn, t = t.next;

          try {
            r();
          } catch (i) {
            throw t ? n() : e = void 0, i;
          }
        }

        e = void 0, i && i.enter();
      };

      if (a) n = function n() {
        s.nextTick(l);
      };else if (!o || i.navigator && i.navigator.standalone) {
        if (u && u.resolve) {
          var c = u.resolve(void 0);

          n = function n() {
            c.then(l);
          };
        } else n = function n() {
          r.call(i, l);
        };
      } else {
        var f = !0,
            p = document.createTextNode("");
        new o(l).observe(p, {
          characterData: !0
        }), n = function n() {
          p.data = f = !f;
        };
      }
      return function (i) {
        var r = {
          fn: i,
          next: void 0
        };
        e && (e.next = r), t || (t = r, n()), e = r;
      };
    };
  }, function (t, e, n) {
    var i = n(13),
        r = n(2),
        o = n(47);
    t.exports = n(4) ? Object.defineProperties : function (t, e) {
      r(t);

      for (var n, s = o(e), u = s.length, a = 0; u > a;) {
        i.f(t, n = s[a++], e[n]);
      }

      return t;
    };
  }, function (t, e, n) {
    var i = n(46),
        r = n(22).concat("length", "prototype");

    e.f = Object.getOwnPropertyNames || function (t) {
      return i(t, r);
    };
  }, function (t, e, n) {
    var i = n(12),
        r = n(28),
        o = n(27)("IE_PROTO"),
        s = Object.prototype;

    t.exports = Object.getPrototypeOf || function (t) {
      return t = r(t), i(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? s : null;
    };
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return {
          e: !1,
          v: t()
        };
      } catch (t) {
        return {
          e: !0,
          v: t
        };
      }
    };
  }, function (t, e, n) {
    var i = n(6);

    t.exports = function (t, e, n) {
      for (var r in e) {
        i(t, r, e[r], n);
      }

      return t;
    };
  }, function (t, e, n) {
    var i = n(5),
        r = n(2),
        o = function o(t, e) {
      if (r(t), !i(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
    };

    t.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, i) {
        try {
          i = n(11)(Function.call, n(45).f(Object.prototype, "__proto__").set, 2), i(t, []), e = !(t instanceof Array);
        } catch (t) {
          e = !0;
        }

        return function (t, n) {
          return o(t, n), e ? t.__proto__ = n : i(t, n), t;
        };
      }({}, !1) : void 0),
      check: o
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(0),
        r = n(13),
        o = n(4),
        s = n(1)("species");

    t.exports = function (t) {
      var e = i[t];
      o && e && !e[s] && r.f(e, s, {
        configurable: !0,
        get: function get() {
          return this;
        }
      });
    };
  }, function (t, e) {
    t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (t, e, n) {
    var i = n(53),
        r = Math.max,
        o = Math.min;

    t.exports = function (t, e) {
      return t = i(t), t < 0 ? r(t + e, 0) : o(t, e);
    };
  }, function (t, e, n) {
    var i = n(0),
        r = i.navigator;
    t.exports = r && r.userAgent || "";
  }, function (t, e, n) {
    var i = n(38),
        r = n(1)("iterator"),
        o = n(15);

    t.exports = n(10).getIteratorMethod = function (t) {
      if (void 0 != t) return t[r] || t["@@iterator"] || o[i(t)];
    };
  }, function (t, e, n) {
    "use strict";

    var i = n(3),
        r = n(20)(2);
    i(i.P + i.F * !n(17)([].filter, !0), "Array", {
      filter: function filter(t) {
        return r(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var i = n(3),
        r = n(37)(!1),
        o = [].indexOf,
        s = !!o && 1 / [1].indexOf(1, -0) < 0;
    i(i.P + i.F * (s || !n(17)(o)), "Array", {
      indexOf: function indexOf(t) {
        return s ? o.apply(this, arguments) || 0 : r(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    var i = n(3);
    i(i.S, "Array", {
      isArray: n(42)
    });
  }, function (t, e, n) {
    "use strict";

    var i = n(3),
        r = n(20)(1);
    i(i.P + i.F * !n(17)([].map, !0), "Array", {
      map: function map(t) {
        return r(this, t, arguments[1]);
      }
    });
  }, function (t, e, n) {
    "use strict";

    var i = n(3),
        r = n(62);
    i(i.P + i.F * !n(17)([].reduce, !0), "Array", {
      reduce: function reduce(t) {
        return r(this, t, arguments.length, arguments[1], !1);
      }
    });
  }, function (t, e, n) {
    var i = Date.prototype,
        r = i.toString,
        o = i.getTime;
    new Date(NaN) + "" != "Invalid Date" && n(6)(i, "toString", function () {
      var t = o.call(this);
      return t === t ? r.call(this) : "Invalid Date";
    });
  }, function (t, e, n) {
    n(4) && "g" != /./g.flags && n(13).f(RegExp.prototype, "flags", {
      configurable: !0,
      get: n(39)
    });
  }, function (t, e, n) {
    n(65)("search", 1, function (t, e, n) {
      return [function (n) {
        "use strict";

        var i = t(this),
            r = void 0 == n ? void 0 : n[e];
        return void 0 !== r ? r.call(n, i) : new RegExp(n)[e](String(i));
      }, n];
    });
  }, function (t, e, n) {
    "use strict";

    n(94);

    var i = n(2),
        r = n(39),
        o = n(4),
        s = /./.toString,
        u = function u(t) {
      n(6)(RegExp.prototype, "toString", t, !0);
    };

    n(7)(function () {
      return "/a/b" != s.call({
        source: "a",
        flags: "b"
      });
    }) ? u(function () {
      var t = i(this);
      return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? r.call(t) : void 0);
    }) : "toString" != s.name && u(function () {
      return s.call(this);
    });
  }, function (t, e, n) {
    "use strict";

    n(51)("trim", function (t) {
      return function () {
        return t(this, 3);
      };
    });
  }, function (t, e, n) {
    for (var i = n(34), r = n(47), o = n(6), s = n(0), u = n(8), a = n(15), l = n(1), c = l("iterator"), f = l("toStringTag"), p = a.Array, h = {
      CSSRuleList: !0,
      CSSStyleDeclaration: !1,
      CSSValueList: !1,
      ClientRectList: !1,
      DOMRectList: !1,
      DOMStringList: !1,
      DOMTokenList: !0,
      DataTransferItemList: !1,
      FileList: !1,
      HTMLAllCollection: !1,
      HTMLCollection: !1,
      HTMLFormElement: !1,
      HTMLSelectElement: !1,
      MediaList: !0,
      MimeTypeArray: !1,
      NamedNodeMap: !1,
      NodeList: !0,
      PaintRequestList: !1,
      Plugin: !1,
      PluginArray: !1,
      SVGLengthList: !1,
      SVGNumberList: !1,
      SVGPathSegList: !1,
      SVGPointList: !1,
      SVGStringList: !1,
      SVGTransformList: !1,
      SourceBufferList: !1,
      StyleSheetList: !0,
      TextTrackCueList: !1,
      TextTrackList: !1,
      TouchList: !1
    }, d = r(h), v = 0; v < d.length; v++) {
      var g,
          y = d[v],
          m = h[y],
          b = s[y],
          _ = b && b.prototype;

      if (_ && (_[c] || u(_, c, p), _[f] || u(_, f, y), a[y] = p, m)) for (g in i) {
        _[g] || o(_, g, i[g], !0);
      }
    }
  }, function (t, e) {}, function (t, e) {
    t.exports = function (t, e, n, i, r, o) {
      var s,
          u = t = t || {},
          a = _typeof(t["default"]);

      "object" !== a && "function" !== a || (s = t, u = t["default"]);
      var l = "function" == typeof u ? u.options : u;
      e && (l.render = e.render, l.staticRenderFns = e.staticRenderFns, l._compiled = !0), n && (l.functional = !0), r && (l._scopeId = r);
      var c;

      if (o ? (c = function c(t) {
        t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), i && i.call(this, t), t && t._registeredComponents && t._registeredComponents.add(o);
      }, l._ssrRegister = c) : i && (c = i), c) {
        var f = l.functional,
            p = f ? l.render : l.beforeCreate;
        f ? (l._injectStyles = c, l.render = function (t, e) {
          return c.call(e), p(t, e);
        }) : l.beforeCreate = p ? [].concat(p, c) : [c];
      }

      return {
        esModule: s,
        exports: u,
        options: l
      };
    };
  }, function (t, e, n) {
    "use strict";

    var i = function i() {
      var t = this,
          e = t.$createElement,
          n = t._self._c || e;
      return n("div", {
        staticClass: "multiselect",
        "class": {
          "multiselect--active": t.isOpen,
          "multiselect--disabled": t.disabled,
          "multiselect--above": t.isAbove
        },
        attrs: {
          tabindex: t.searchable ? -1 : t.tabindex
        },
        on: {
          focus: function focus(e) {
            t.activate();
          },
          blur: function blur(e) {
            !t.searchable && t.deactivate();
          },
          keydown: [function (e) {
            return "button" in e || !t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"]) ? e.target !== e.currentTarget ? null : (e.preventDefault(), void t.pointerForward()) : null;
          }, function (e) {
            return "button" in e || !t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"]) ? e.target !== e.currentTarget ? null : (e.preventDefault(), void t.pointerBackward()) : null;
          }],
          keypress: function keypress(e) {
            return "button" in e || !t._k(e.keyCode, "enter", 13, e.key, "Enter") || !t._k(e.keyCode, "tab", 9, e.key, "Tab") ? (e.stopPropagation(), e.target !== e.currentTarget ? null : void t.addPointerElement(e)) : null;
          },
          keyup: function keyup(e) {
            if (!("button" in e) && t._k(e.keyCode, "esc", 27, e.key, "Escape")) return null;
            t.deactivate();
          }
        }
      }, [t._t("caret", [n("div", {
        staticClass: "multiselect__select",
        on: {
          mousedown: function mousedown(e) {
            e.preventDefault(), e.stopPropagation(), t.toggle();
          }
        }
      })], {
        toggle: t.toggle
      }), t._v(" "), t._t("clear", null, {
        search: t.search
      }), t._v(" "), n("div", {
        ref: "tags",
        staticClass: "multiselect__tags"
      }, [t._t("selection", [n("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: t.visibleValues.length > 0,
          expression: "visibleValues.length > 0"
        }],
        staticClass: "multiselect__tags-wrap"
      }, [t._l(t.visibleValues, function (e, i) {
        return [t._t("tag", [n("span", {
          key: i,
          staticClass: "multiselect__tag"
        }, [n("span", {
          domProps: {
            textContent: t._s(t.getOptionLabel(e))
          }
        }), t._v(" "), n("i", {
          staticClass: "multiselect__tag-icon",
          attrs: {
            "aria-hidden": "true",
            tabindex: "1"
          },
          on: {
            keypress: function keypress(n) {
              if (!("button" in n) && t._k(n.keyCode, "enter", 13, n.key, "Enter")) return null;
              n.preventDefault(), t.removeElement(e);
            },
            mousedown: function mousedown(n) {
              n.preventDefault(), t.removeElement(e);
            }
          }
        })])], {
          option: e,
          search: t.search,
          remove: t.removeElement
        })];
      })], 2), t._v(" "), t.internalValue && t.internalValue.length > t.limit ? [t._t("limit", [n("strong", {
        staticClass: "multiselect__strong",
        domProps: {
          textContent: t._s(t.limitText(t.internalValue.length - t.limit))
        }
      })])] : t._e()], {
        search: t.search,
        remove: t.removeElement,
        values: t.visibleValues,
        isOpen: t.isOpen
      }), t._v(" "), n("transition", {
        attrs: {
          name: "multiselect__loading"
        }
      }, [t._t("loading", [n("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: t.loading,
          expression: "loading"
        }],
        staticClass: "multiselect__spinner"
      })])], 2), t._v(" "), t.searchable ? n("input", {
        ref: "search",
        staticClass: "multiselect__input",
        style: t.inputStyle,
        attrs: {
          name: t.name,
          id: t.id,
          type: "text",
          autocomplete: "nope",
          placeholder: t.placeholder,
          disabled: t.disabled,
          tabindex: t.tabindex
        },
        domProps: {
          value: t.search
        },
        on: {
          input: function input(e) {
            t.updateSearch(e.target.value);
          },
          focus: function focus(e) {
            e.preventDefault(), t.activate();
          },
          blur: function blur(e) {
            e.preventDefault(), t.deactivate();
          },
          keyup: function keyup(e) {
            if (!("button" in e) && t._k(e.keyCode, "esc", 27, e.key, "Escape")) return null;
            t.deactivate();
          },
          keydown: [function (e) {
            if (!("button" in e) && t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"])) return null;
            e.preventDefault(), t.pointerForward();
          }, function (e) {
            if (!("button" in e) && t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"])) return null;
            e.preventDefault(), t.pointerBackward();
          }, function (e) {
            if (!("button" in e) && t._k(e.keyCode, "delete", [8, 46], e.key, ["Backspace", "Delete"])) return null;
            e.stopPropagation(), t.removeLastElement();
          }],
          keypress: function keypress(e) {
            return "button" in e || !t._k(e.keyCode, "enter", 13, e.key, "Enter") ? (e.preventDefault(), e.stopPropagation(), e.target !== e.currentTarget ? null : void t.addPointerElement(e)) : null;
          }
        }
      }) : t._e(), t._v(" "), t.isSingleLabelVisible ? n("span", {
        staticClass: "multiselect__single",
        on: {
          mousedown: function mousedown(e) {
            return e.preventDefault(), t.toggle(e);
          }
        }
      }, [t._t("singleLabel", [[t._v(t._s(t.currentOptionLabel))]], {
        option: t.singleValue
      })], 2) : t._e(), t._v(" "), t.isPlaceholderVisible ? n("span", {
        staticClass: "multiselect__placeholder",
        on: {
          mousedown: function mousedown(e) {
            return e.preventDefault(), t.toggle(e);
          }
        }
      }, [t._t("placeholder", [t._v("\n          " + t._s(t.placeholder) + "\n        ")])], 2) : t._e()], 2), t._v(" "), n("transition", {
        attrs: {
          name: "multiselect"
        }
      }, [n("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: t.isOpen,
          expression: "isOpen"
        }],
        ref: "list",
        staticClass: "multiselect__content-wrapper",
        style: {
          maxHeight: t.optimizedHeight + "px"
        },
        attrs: {
          tabindex: "-1"
        },
        on: {
          focus: t.activate,
          mousedown: function mousedown(t) {
            t.preventDefault();
          }
        }
      }, [n("ul", {
        staticClass: "multiselect__content",
        style: t.contentStyle
      }, [t._t("beforeList"), t._v(" "), t.multiple && t.max === t.internalValue.length ? n("li", [n("span", {
        staticClass: "multiselect__option"
      }, [t._t("maxElements", [t._v("Maximum of " + t._s(t.max) + " options selected. First remove a selected option to select another.")])], 2)]) : t._e(), t._v(" "), !t.max || t.internalValue.length < t.max ? t._l(t.filteredOptions, function (e, i) {
        return n("li", {
          key: i,
          staticClass: "multiselect__element"
        }, [e && (e.$isLabel || e.$isDisabled) ? t._e() : n("span", {
          staticClass: "multiselect__option",
          "class": t.optionHighlight(i, e),
          attrs: {
            "data-select": e && e.isTag ? t.tagPlaceholder : t.selectLabelText,
            "data-selected": t.selectedLabelText,
            "data-deselect": t.deselectLabelText
          },
          on: {
            click: function click(n) {
              n.stopPropagation(), t.select(e);
            },
            mouseenter: function mouseenter(e) {
              if (e.target !== e.currentTarget) return null;
              t.pointerSet(i);
            }
          }
        }, [t._t("option", [n("span", [t._v(t._s(t.getOptionLabel(e)))])], {
          option: e,
          search: t.search
        })], 2), t._v(" "), e && (e.$isLabel || e.$isDisabled) ? n("span", {
          staticClass: "multiselect__option",
          "class": t.groupHighlight(i, e),
          attrs: {
            "data-select": t.groupSelect && t.selectGroupLabelText,
            "data-deselect": t.groupSelect && t.deselectGroupLabelText
          },
          on: {
            mouseenter: function mouseenter(e) {
              if (e.target !== e.currentTarget) return null;
              t.groupSelect && t.pointerSet(i);
            },
            mousedown: function mousedown(n) {
              n.preventDefault(), t.selectGroup(e);
            }
          }
        }, [t._t("option", [n("span", [t._v(t._s(t.getOptionLabel(e)))])], {
          option: e,
          search: t.search
        })], 2) : t._e()]);
      }) : t._e(), t._v(" "), n("li", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: t.showNoResults && 0 === t.filteredOptions.length && t.search && !t.loading,
          expression: "showNoResults && (filteredOptions.length === 0 && search && !loading)"
        }]
      }, [n("span", {
        staticClass: "multiselect__option"
      }, [t._t("noResult", [t._v("No elements found. Consider changing the search query.")], {
        search: t.search
      })], 2)]), t._v(" "), n("li", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: t.showNoOptions && 0 === t.options.length && !t.search && !t.loading,
          expression: "showNoOptions && (options.length === 0 && !search && !loading)"
        }]
      }, [n("span", {
        staticClass: "multiselect__option"
      }, [t._t("noOptions", [t._v("List is empty.")])], 2)]), t._v(" "), t._t("afterList")], 2)])])], 2);
    },
        r = [],
        o = {
      render: i,
      staticRenderFns: r
    };

    e.a = o;
  }]);
});